import React, { useState, useEffect } from "react";
import { Input, FormGroup, Label, Button } from "reactstrap";
import { useNavigate } from "react-router-dom";
import axios from "axios";
import { useSelector, useDispatch } from "react-redux";
import { toast } from "react-toastify";
import CKEditor from "react-ckeditor-component";

const AddBlog = () => {
  const [formData, setFormData] = useState({
    category_id: "",
    blog_title: "",
    short_description: "",
    description: "",
    status: 1,
    thumbnail: "",
  });
  const [errors, setErrors] = useState({});
  const [text, setText] = useState("");
  const [blogCategories, setBlogCategories] = useState([]);
  const {
    AuthReducer: { auth }
  } = useSelector((state) => state);
  const navigate = useNavigate();
  const dispatch = useDispatch();

  useEffect(() => {
    axios(`/api/admin/v1/all-blog-category/?type=1`, {
      headers: {
        Authorization: `Bearer ${auth.token}`,
      },
    })
      .then(({ data }) => {
        setBlogCategories(data?.BlogCategories);
      })
      .catch((err) => console.error(err));
},[]);

  const handleText = (e) => {
    const descriptions = e.editor.getData();
    setText(descriptions);
  }

  const inputHandler = (e) => {
    const { name, value } = e.target;
    if (name === "thumbnail") {
      setFormData({ ...formData, [name]: e.target.files[0] });
    }
    if (name === "status") {
      setFormData({ ...formData, [name]: e.target.checked ? 1 : 0 });
    } else {
      setFormData({ ...formData, [name]: value });
    }
  };
  const handleSubmit = () => {
    const form = new FormData();
    // for (const key in formData) {
    //   form.append([key], formData[key]);
    // }
    form.append('category_id', formData.category_id);
    form.append('blog_title', formData.blog_title);
    form.append('short_description', formData.short_description);
    form.append('description', text);
    form.append('thumbnail', formData.thumbnail);
    form.append('status', formData.status);
    axios
      .post(`/api/admin/v1/add-blog`, form, {
        headers: {
          Authorization: `Bearer ${auth?.token}`,
        },
      })
      .then((res) => {
        toast.success(res.data?.message);
        navigate(-1);
      })
      .catch((err) => {
        toast.error(err.response.data);
        setErrors(err.response.data);
      });
  };


  return (
    <div>
      <div className="row my-3">
        <div className="col-md-12">
          <h4 className="text-white">Add Blog</h4>
        </div>
      </div>
      <div className="bg-white px-3 py-4 rounded-2  my-4">
        <div className="row">
          <div className="col-md-4 offset-md-1">
            <FormGroup>
              <Label>Blog Title <span className="text-danger fs-4">*</span></Label>
              <Input
                invalid={Boolean(errors?.blog_title)}
                value={formData?.blog_title}
                name="blog_title"
                onChange={inputHandler}
              />
              <span className="d-block text-danger"> {errors?.blog_title} </span>
            </FormGroup>
          </div>
          <div className="col-md-4 offset-md-1">
            <FormGroup>
              <Label>Category <span className="text-danger fs-4">*</span></Label>
              <Input
                value={formData?.category_id}
                type="select"
                name="category_id"
                onChange={inputHandler}
              >
                <option value="">Select Option</option>
                {blogCategories?.map?.((item) => {
                  return (
                    <option value={item.id} key={item.id}>
                      {item?.category_name}
                    </option>
                  );
                })}
              </Input>
              <span className="d-block text-danger">{errors?.category_id}</span>
            </FormGroup>
          </div>
          <div className="col-md-4 offset-md-1">
            <FormGroup>
              <Label>Upload Thumbnail</Label>
              <Input
                type="file"
                invalid={Boolean(errors?.thumbnail)}
                name="thumbnail"
                onChange={(e) =>
                  setFormData((prev) => ({
                    ...prev,
                    [e.target.name]: e.target.files[0],
                  }))
                }
              />
              <span className="d-block text-danger">{errors?.thumbnail}</span>
            </FormGroup>
          </div>
          <div className="col-md-4 offset-md-1">
            <FormGroup>
              <Label>Short Description <span className="text-danger fs-4">*</span></Label>
              <Input
                type="textarea"
                invalid={Boolean(errors?.short_description)}
                value={formData?.short_description}
                name="short_description"
                onChange={inputHandler}
              />
              <span className="d-block text-danger"> {errors?.short_description} </span>
            </FormGroup>
          </div>
          <div className="col-md-9 offset-md-1">
            <FormGroup>
              <Label>Description</Label>
              <CKEditor
                content={text}
                events={{
                  "change": handleText
                }}
              />
            </FormGroup>
          </div>
          <div className="col-md-4 offset-md-1">
            <FormGroup switch>
              <Input
                type="switch"
                checked={formData?.status}
                onChange={inputHandler}
                name="status"
              />
              <Label check>Status</Label>
            </FormGroup>
          </div>
          <div className="col-md-4 offset-md-4">
            <Button color="primary" onClick={handleSubmit}>
              Submit
            </Button>
            <Button className="ms-3" onClick={() => navigate(-1)}>
              Cancel
            </Button>
          </div>
        </div>
      </div>
    </div>
  );
};

export default AddBlog;
